import { useParams, useNavigate } from "react-router-dom";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { IPaymentFailed } from "../../models/user/payment/Payment";
import paymentStyle from "./PaymentStyle";
import { ErrorOutlineOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const PaymentCancel: React.FC = () => {
  const { errorCode } = useParams();
  const { t } = useTranslation();

  const navigate = useNavigate();

  let errorData: IPaymentFailed | null = null;

  if (errorCode) {
    errorData = JSON.parse(atob(errorCode));
  }

  const handleHome = () => {
    const origin = sessionStorage.getItem("payment_origin");
    const fallback = "/customer/dashboard";
    const target = origin || fallback;
    // Clear after use so future navigations aren't affected
    sessionStorage.removeItem("payment_origin");
    navigate(target);
  };

  return (
    <Box sx={paymentStyle.pSuccesMain}>
      <Card
        sx={{
          width: "40%",
          height: "250px",
          "@media (max-width:768px)": {
            width: "100%",
          },
        }}
      >
        <CardContent
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "20px",
            }}
          >
            <ErrorOutlineOutlined fontSize="large" sx={{ color: "red" }} />
            <Typography sx={paymentStyle.pFailMsg}>
              {t("Oops! Payment Failed")}
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ ...paymentStyle.textFont, textAlign: "center" }}>
              {errorData?.message}
            </Typography>
          </Box>
          <Box sx={paymentStyle.paySection}>
            <Button
              onClick={handleHome}
              type="button"
              name="home"
              variant="contained"
            >
              {t("Back to home")}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PaymentCancel;
